import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

import type {
  SortFieldProps as ISortFieldProps,
  FiltersFieldProps as IFiltersFieldProps,
  FiltersFieldInstance,
} from '../types'

import { SortField, FiltersField, FieldContainer } from '../ui'

@Component({
  components: {
    SortField,
    FiltersField,
    FieldContainer,
  },
})
export default class ControlBar extends Vue {
  @Ref('filtersField') private readonly filtersFieldRef?: FiltersFieldInstance

  @Prop({ type: Object }) private readonly sortFieldProps?: ISortFieldProps

  @Prop({ type: Object })
  private readonly filtersFieldProps?: IFiltersFieldProps

  private get isShowSortField() {
    return !!this.sortFieldProps?.items.length
  }

  private onSubmit() {
    if (this.filtersFieldProps?.onSubmit) {
      this.filtersFieldProps?.onSubmit()
    }

    if (this.sortFieldProps?.onSubmit) {
      this.sortFieldProps?.onSubmit()
    }
  }

  private onChangeSearchInputValue(value: string) {
    this.$emit('change:search-input-value', value)
  }
}
